export abstract class EntityBase {
  id: number = 0;

  constructor(id?: number) {
    this.id = id??0;
  }

  static includes(list: EntityBase[], item: EntityBase|null): boolean {
    if (item==null) {
       return false;
    }
    return (EntityBase.indexOf(list, item)!=-1);
  }

  static indexOf(list: EntityBase[], item: EntityBase): number {
    if (list==null || item==null) {
       return -1;
    }
    for (var i = 0; i< list.length; i++) {
       if (list[i].id==item.id) {
          return i;
       }
    }
    return -1;
  }

  static removeValueFromList(list: EntityBase[], id: number): void {
    if (list==null || list.length==0 || id==null) {
       return;
    }
    for (var i = 0; i< list.length; i++) {
       if (list[i].id==id) {
          list.splice(i, 1);
          return;
       }
    }
  }

  static getValueFromList(list: EntityBase[], id: number): EntityBase|null {
    if (list==null || list.length==0) {
       return null;
    }
    for (var i = 0; i< list.length; i++) {
       if (list[i].id==id) {
          return list[i];
       }
    }
    return null;
  }

  static convertListToIDsArray(list: EntityBase[]): number[] {
     var res = [];
     for(var i=0; i<list.length; i++) {
        res.push(list[i].id);
     }
     return res;
  }
}